import type { GraphqlError, GraphqlResult } from "./GraphqlResult";

const toGraphqlError = (
  result: GraphqlResult<unknown>,
): GraphqlError | undefined => {
  const errors = result.errors ?? [];
  if (result.error) {
    return { message: errors[0]?.message ?? result.error, errors };
  }
  if (errors.length > 0) {
    return { message: errors[0]?.message ?? "GraphQL error", errors };
  }
  return undefined;
};

export default toGraphqlError;
